<div class="index-shell">
    <app-header [breadcrumbs]="['System settings', 'Positions']"
                [links]="['/settings/general-information', '/settings/positions']"
                mainHeading="Positions" />
    <div>
        <table class="cll-table">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Description</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Administrator</td>
                    <td>Highest level of access.</td>
                </tr>
                <tr>
                    <td>Commissioner Admin</td>
                    <td>Highest level of commissioner access.</td>
                </tr>
                <tr>
                    <td>Commissioner User</td>
                    <td>Lowest level of commissioner access.</td>
                </tr>
                <tr>
                    <td>Provider Admin</td>
                    <td>Highest level of provider access.</td>
                </tr>
                <tr>
                    <td>Provider User</td>
                    <td>Lowest level of provider access.</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
